export default __webpack_public_path__ + "1e11e0e02bf1122ec372e32a7d2086f3.svg";